module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Medium.98c0721.woff";